<div class="main-banner item-bg-one">
  <div class="particles-host" [ngStyle]="myStyle">
    <ngx-particles [id]="particlesCanvasId" [options]="myParams"></ngx-particles>
  </div>
  <div class="creative-banner-three"></div>

  <!-- Controles de Partículas -->
  <div class="particle-controls">
    @for (theme of availableThemes; track theme) {
      <button
        type="button"
        class="particle-btn"
        (click)="setParticleTheme(theme, $event)"
        [class.active]="currentTheme === theme"
        [title]="'particles.themes.' + theme | translate">
        <i [class]="getThemeIcon(theme)"></i> {{ 'particles.themes.' + theme | translate }}
      </button>
    }
  </div>

  <!-- Indicador del Tema Actual -->
  <div class="theme-indicator">
    <span class="theme-label">{{ 'particles.themeLabel' | translate }}: {{ 'particles.themes.' + currentTheme | translate }}</span>
  </div>

  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="main-banner-text">
          <h4>{{ 'hero.kicker' | translate }}</h4>
          <h1>{{ 'hero.title' | translate }} <span>{{ 'hero.highlight' | translate }}</span></h1>
          <p>{{ 'hero.subtitle' | translate }}</p>

        </div>
      </div>
    </div>
  </div>
</div>

<app-welcome></app-welcome>

<app-about></app-about>

<app-strategy></app-strategy>

<app-who-we-are></app-who-we-are>

<app-cta></app-cta>

<app-skill></app-skill>

<!--<app-funfacts></app-funfacts>-->

<app-team></app-team>

<app-how-we-work hidden></app-how-we-work>

<app-services></app-services>

<app-why-we-different hidden></app-why-we-different>

<!--<app-work></app-work>-->

<!--<app-pricing></app-pricing>-->

<!--<app-faq></app-faq>-->

<app-feedback hidden></app-feedback>

<app-blog></app-blog>

<app-partner></app-partner>

<app-subscribe></app-subscribe>

<app-contact></app-contact>
